<template>
  <div>
    <div class="customer-research">
      <CustomerResearch @customer-result="body = $event" />
    </div>
    <div class="customer-list list">
      <div class="customer-list-header list-header">
        <ul>
          <li v-for="(item, index) in header" :key="index">{{item.libelle}}</li>
          <li>{{$_('turnover_limit')}} {{getCurrentYear}} ({{getDev}})</li>
          <li>{{$_('turnover_limit')}} {{getCurrentLastYear}} ({{getDev}})</li>
        </ul>
      </div>
      <div class="customer-list-body list-body">
        <transition-group tag="div" name="fade">
          <ul v-for="customer in body" :key="customer.TNCLI" @click="vManageClick(customer)">
            <li>{{customer.TNCLI}}</li>
            <li>{{customer.TLIBCLI}}</li>
            <li>{{customer.TVILLE}}</li>
            <li>{{customer.TLPAYS}}</li>
            <li>{{customer.TACTIF == 1 ? $_("actif") : $_("inactive")}}</li>
            <li>{{customer.TLIB_CATCLI}}</li>
            <li>{{customer.TCAN}}</li>
            <li>{{customer.TCAN1}}</li>
          </ul>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerResearch from "@/modules/client/components/CustomerResearch";

export default {
  data() {
    return {
      header: [
        { libelle: this.$_("customer_number") },
        { libelle: this.$_("customer_name") },
        { libelle: this.$_("city") },
        { libelle: this.$_("country") },
        { libelle: this.$_("actif") },
        { libelle: this.$_("customer_category")}
      ],
      body: Array(),
      selectedValue: ""
    };
  },
  components: {
    CustomerResearch
  },
  computed: {
    getCurrentYear() {
      return this.body[0] !== undefined ? this.body[0].TCAN_ANNEE : '';
    },
    getCurrentLastYear() {
      return this.body[0] !== undefined ? this.body[0].TCAN1_ANNEE : '';
    },
    getDev() {
      return this.body[0] !== undefined ? this.body[0].TCDEV : '';
    }
  },
  methods: {
    vSelectCustomer(customer) {
      localStorage.setItem("satabapp-customer", JSON.stringify(customer));
      this.$emit("load-customer", {customer});

      if (this.$route.name !== 'saisieechantillon') {
        window.location.reload();
      }
    },
    vManageClick(customer) {
      this.vSelectCustomer(customer);
    }
  }
};
</script>

<style scoped>
.valid-container {
  margin-top: 50px;
}
.list {
  width: 100%;
}
.list ul {
  padding: 0px;
  margin: 0px;
  display: flex;
}
.list ul li {
  list-style-type: none;
}
.list-header ul {
  display: flex;
  align-items: center;
}
.list-header ul li {
  padding: 0px 30px;
  text-align: left;
  width: calc(100% / 8);
}
.list-body ul {
  border: solid 1px #e9e9e9;
  margin: 10px 0px;
  height: 60px;
}
.list-body ul li {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0px 30px;
  font-size: var(--fz-md);
  color: #585858;
  transition: background-color 0.4s;
  width: calc(100% / 8);
}
.list-body ul:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.pagination-container {
  text-align: center;
  margin-top: 20px;
  width: 100%;
}
.customer-research {
  margin: 40px 0px;
}
</style>